// extracted by mini-css-extract-plugin
module.exports = {"menu":"jIZEqm0q6UGHapD6g3MSRQ==","tab":"JcDmFX1VvR+qpG7jZUBUlw==","link":"qeD6KJ-PRvA+2Y2t5tZqQA==","active":"rpvTHZXjsm34XbhuGpwXjQ=="};